export default __webpack_public_path__ + "static/media/16.4af15010.jpg";